import { AnchorHTMLAttributes, DetailedHTMLProps, FC } from 'react'
import { Link } from '@tanstack/react-router'
import styled from '@emotion/styled'

type AProps = DetailedHTMLProps<
  AnchorHTMLAttributes<HTMLAnchorElement>,
  HTMLAnchorElement
> & { href: string }

function sameOrigin(a: string, b: string) {
  const base = window.location.origin
  const urlA = new URL(a, base)
  const urlB = new URL(b, base)
  return urlA.origin === urlB.origin
}

const baseStyles = `
  display: inline-block;
  text-decoration: none;

  &:focus-visible {
    outline: 2px solid rgba(0, 125, 255, 0.5);
    outline-offset: 1px;
    border-radius: 4px;
  }
`

export const StyledAnchor = styled.a`${baseStyles}`
const StyledLink = styled(Link)`${baseStyles}`

export const A: FC<AProps> = ({
  children,
  onClick,
  target,
  rel,
  href,
  ...restProps
}) => {
  const isInternalLink = sameOrigin(href, window.location.href) && target === undefined

  if (isInternalLink) {
    return (
      <StyledLink
        to={href}
        onClick={onClick}
        {...restProps}
      >
        {children}
      </StyledLink>
    )
  }

  return (
    <StyledAnchor 
      href={href}
      target={target ?? '_blank'}
      rel={rel ?? 'noopener noreferrer'}
      onClick={onClick}
      {...restProps}
    >
      {children}
    </StyledAnchor>
  )
}
